import React from "react";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import useSnackbar from "../../hooks/useSnackbar";

import { getTransactionCustomerRefundDetails, getTransactionBillPaymentPayeeAddress } from "../../api/transaction-type";
import { slugMap } from "../../config/slug-config";
import { Link, useParams } from "react-router-dom";
import { Box, Typography, Button, Grid, Tabs, Tab, CircularProgress, } from "@mui/material";
import TabPanel from "../../components/TabPanel";
import { GridComp4, GridComp2,GridComp6, GridComp12 } from "../../components/GridComponents";

import CustomerRefundApply from "./customer-refund/apply";
import CustomerRefundRefundMethod from "./customer-refund/refund-method";
import CustomerRefundRelationship from "./customer-refund/relationships";
import CustomerRefundCommunication from "./customer-refund/communication";
import CustomerRefundSystemInformation from "./customer-refund/system-information";
import CustomerRefundCustom from "./customer-refund/custom";
import CustomerRefundEft from "./customer-refund/eft";
import { CustomCheckBox } from "../../components/CheckboxComp";

export default function TransactionTypeCustomerRefund() {

  const snackbar = useSnackbar();
  const { data: user } = useSelector((state) => state.user);
  const params = useParams();

  const pageDetail = slugMap[params.slug];

  // const [tableRefreshCount, setTableRefreshCount] = useState(0);
  // function refreshTable () {
  //     setTableRefreshCount(prev => prev + 1);
  // }

  const [rowData, setRowData] = useState([]);

  const [payeeAddData, setPayeeAddData] = useState([]);

  const [loading, setLoading] = useState(false);

  /*----------------Tabs-----------------*/
  const [tabIndex, setTabIndex] = useState(0);
  const [subTabIndex, setSubTabIndex] = useState(0);

  useEffect(() => {
    if (user.token) {
      getTransactionDocCustomerRefundDetailsData();
      getTransactionDocBillPaymentPayeeAddData();
    }
  }, []);

  async function getTransactionDocCustomerRefundDetailsData() {
    setLoading(true);
    try {
      const { data } = await getTransactionCustomerRefundDetails(user.token, { tranid: params.docNo, });
      setRowData(data.data.details[0]);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
      snackbar.showError("Error In Loading Data.");
      return { error: true };
    }
    finally {
      setLoading(false);
    }
  }

  async function getTransactionDocBillPaymentPayeeAddData() {
    try {
      const { data } = await getTransactionBillPaymentPayeeAddress(user.token, { id: params.docNo });
      setPayeeAddData(data.data.data[0]);
    } catch (error) {
      console.log(error);
      snackbar.showError("Error In Loading Data.");
      return { error: true }
    } finally {
      // setLoading(false);
    }
  }

  return loading ? (
    <>
      <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          <Typography component="h5" fontWeight={500} className="pageHeading1">
            Primary Information
          </Typography>
          <Link to={"/transaction-type/" + params.slug}>
            <Button size="small" variant="contained" className="backBtn">
              Go Back
            </Button>
          </Link>
        </Box>
        <Box className="viewDetilsBox">
          <Grid container className="mb-2">
            <Grid item xs={12}>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CircularProgress></CircularProgress>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Box>
      <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          <Typography component="h5" fontWeight={500} className="pageHeading1">
            Classification
          </Typography>
        </Box>
        <Box className="viewDetilsBox">
          <Grid container className="mb-2">
            <Grid item xs={12}>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CircularProgress></CircularProgress>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </>
  ) : (
    <>
     <Typography component="h4" fontWeight={500} className="pageTitle">
        Customer Refund
      </Typography>

      {/* {rowData?.map((el, index) => (<> */}
        <Typography component="h5" style={{marginBottom: "10px"}}>
          <span className="para-no"><strong>{rowData?.tranid}</strong> {rowData?.customer}</span>
        </Typography>
      {/*Primary Information*/}
      <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          <Typography component="h5" fontWeight={500} className="pageHeading1">
            Primary Information
          </Typography>
          <Link to={"/transaction-type/" + params.slug}>
            <Button size="small" variant="contained" className="backBtn">
              Go Back
            </Button>
          </Link>
        </Box>
        <Box className="viewDetilsBox">
          {/* {rowData?.map((d, i) => ( */}
            <>
              <Grid container className="mb-2">
              <GridComp4 title={"TRANSACTION NUMBER"} data={rowData?.transaction_number} />
              <GridComp4 title={"A/R ACCOUNT"} data={rowData?.ar_account} />
              <GridComp4 title={"DATE"} data={rowData?.date} />
              <GridComp4 title={"CUSTOMER"} data={rowData?.customer} />
              <GridComp4 title={"REFUND AMOUNT"} data={rowData?.refund_amount} />
              <GridComp4 title={"POSTING PERIOD"} data={rowData?.posting_period} />
              <GridComp2 title={"BALANCE"} data={rowData?.balance} />
              <GridComp2 title={"CONSOLIDATED BALANCE"} data={rowData?.balance} />
              <GridComp4 title={"CURRENCY"} data={rowData?.currency} />
              <GridComp4 title={"MEMO"} data={rowData?.memo} />
              <GridComp4 title={"BANK ACCOUNT"} data={rowData?.bank_account} />
              <CustomCheckBox
                    title={"TO BE PRINTED"}
                    data={rowData?.to_be_printed}
                  />
              <GridComp4 title={"EXCHANGE RATE"} data={rowData?.exchangerate} />
      
               
           




              </Grid>
            </>
          {/* ))} */}
        </Box>
      </Box>

      {/*Classification*/}
      <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          <Typography component="h5" fontWeight={500} className="pageHeading1">
            Classification
          </Typography>
        </Box>
        <Box className="viewDetilsBox">
          {/* {rowData?.map((d, i) => ( */}
            <>
              <Grid container className="mb-2">
                <GridComp4 title={"SUBSIDIARY"} data={rowData?.subsidiary} />
                <GridComp4 title={"DEPARTMENT"} data={rowData?.department} />
                <GridComp4 title={"SERVICE_LINE"} data={rowData?.service_line} />
              </Grid>
            </>
          {/* ))} */}
        </Box>
      </Box>

 {/*Payment Information*/}
 <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          <Typography component="h5" fontWeight={500} className="pageHeading1">
          Payment Information
          </Typography>
        </Box>
        <Box className="viewDetilsBox">
          {/* {rowData?.map((d, i) => ( */}
            <>
              <Grid container className="mb-2">
                <GridComp6 title={"REFUND METHOD"} data={rowData?.refund_method} />
                <GridComp6 title={"CHECK#"} data={rowData?.check} />
                <GridComp12 title={"LOCATION"} data={rowData?.location} />
              </Grid>
            </>
          {/* ))} */}
        </Box>
      </Box>

      <Box>
        <Box className="viewBox " sx={{ maxWidth: { xs: 320, sm: 480, md: "100%" }, bgcolor: '#fff' }}>
          <Tabs
            value={tabIndex}
            // onChange={handleChange}
            onChange={(e, nv) => {
              setTabIndex(nv);
            }}
            variant="scrollable"
            scrollButtons="auto"
            aria-label="scrollable auto tabs example"
            className="tabs-bkg tabs-plr-15"
          >
            <Tab label="Apply" />
            <Tab label="Refund Method" />
            <Tab label="Payee Address" />
            <Tab label="Relationships" />
            <Tab label="Communication" />
            <Tab label="System Information" />
            <Tab label="Custom" />
            <Tab label="EFT" />
          </Tabs>

          {/*Apply*/}
          <TabPanel value={tabIndex} index={0}>
          {tabIndex === 0 &&   <CustomerRefundApply />}
          </TabPanel>
          {/*Apply*/}

          {/* Refund Method */}
          <TabPanel value={tabIndex} index={1}>
          {tabIndex === 1 &&     <CustomerRefundRefundMethod tabIndexP={tabIndex} />}
          </TabPanel>
          {/* Refund Method */}

          {/* Payee Address */}
          <TabPanel value={tabIndex} index={2}>
            <Box className="viewDetilsBox">
              {/* {payeeAddData.map((p, i) => ( */}
                <>
                  <Grid container className="mb-2">
                    <GridComp6 title={"PAY TO"} data={payeeAddData?.pay_to} />
                    <Grid item xs={12} sm={12} md={12} className="m-b-10 tFormlabel"><Link>Map</Link></Grid>
                  </Grid>
                </>
              {/* ))} */}
            </Box>
          </TabPanel>
          {/* Payee Address */}

          {/* Relationship */}
          <TabPanel value={tabIndex} index={3}>
          {tabIndex === 3 && <CustomerRefundRelationship tabIndexP={tabIndex} />}
          </TabPanel>
          {/* Relationship */}

          {/* Communication */}
          <TabPanel value={tabIndex} index={4}>
             {tabIndex === 4 && <CustomerRefundCommunication tabIndexP={tabIndex} />}
          </TabPanel>
          {/* Communication */}

          {/* SystemInformation */}
          <TabPanel value={tabIndex} index={5}>
             {tabIndex === 5 && <CustomerRefundSystemInformation tabIndexP={tabIndex} />}
          </TabPanel>
          {/* SystemInformation */}

          {/* "Custom */}
          <TabPanel value={tabIndex} index={6}>
             {tabIndex === 6 && <CustomerRefundCustom tabIndexP={tabIndex} />}
          </TabPanel>
          {/* "Custom */}

          {/* Eft */}
          <TabPanel value={tabIndex} index={7}>
             {tabIndex === 7 && <CustomerRefundEft tabIndexP={tabIndex} />}
          </TabPanel>
          {/* Eft */}

        </Box>
      </Box>

    </>
  );
}
